var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/cake"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cake"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 16.5H16.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.33252 16.5V9.75C2.33252 8.505 3.45002 7.5 4.83002 7.5H13.1625C14.5425 7.5 15.66 8.505 15.66 9.75V16.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.16992 7.5V5.3775C4.16992 4.4775 4.97992 3.75 5.98492 3.75H12.0224C13.0199 3.75 13.8299 4.4775 13.8299 5.3775V7.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.64746 10.4844L2.92496 10.4919C3.47996 10.4994 3.92246 10.9494 3.92246 11.5044V11.7519C3.92246 12.3069 4.37246 12.7644 4.93496 12.7644C5.48996 12.7644 5.94746 12.3144 5.94746 11.7519V11.5194C5.94746 10.9644 6.39746 10.5069 6.95996 10.5069C7.51496 10.5069 7.97246 10.9569 7.97246 11.5194V11.7519C7.97246 12.3069 8.42246 12.7644 8.98496 12.7644C9.53996 12.7644 9.99746 12.3144 9.99746 11.7519V11.5194C9.99746 10.9644 10.4475 10.5069 11.01 10.5069C11.565 10.5069 12.0225 10.9569 12.0225 11.5194V11.7519C12.0225 12.3069 12.4725 12.7644 13.035 12.7644C13.59 12.7644 14.0475 12.3144 14.0475 11.7519V11.5194C14.0475 10.9644 14.4975 10.5069 15.06 10.5069H15.3975",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6 3.75V2.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12 3.75V2.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9 3.75V1.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.2e59c2da69c6d4d323435f5e02bba054.svg";
export { ForwardRef as ReactComponent };